module.exports = __webpack_public_path__ + "static/media/uhn-logo.05a1b606.png";